module.exports = __webpack_public_path__ + "1792395595471/images/europe.4d55246.png";